const getPositionNumberColors = (
  isMyScore?: boolean,
  isBitcasino?: boolean,
) => {
  if (isMyScore) {
    if (isBitcasino) {
      return 'bg-piccolo text-goku';
    }
    return 'bg-piccolo text-goten';
  }
  return 'bg-gohan text-trunks';
};

export default getPositionNumberColors;
